<h2 mat-dialog-title class="dialog-title">Reacties</h2>

<mat-dialog-content class="dialog-content">
  @for (vote of votes | keyvalue; track vote) {
    <div class="reaction-group">
      <div class="reaction-group__header">
        <img [src]="findVote(vote.key).icon" class="reaction-group__icon"
          alt="icoon {{findVote(vote.key).value}}" />
        <span class="reaction-group__label">{{ findVote(vote.key).value }}</span>
        <span class="reaction-group__count">{{ vote.value.length }}</span>
      </div>
      <div class="reaction-group__members">
        @for (v of vote.value; track v) {
          <span class="reaction-group__member">{{ v.memberName }}</span>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Sluiten</button>
</mat-dialog-actions>
